import { useState } from "react";
import { ZoomIn, X } from "lucide-react";
import { useAppContext } from "../../context/AppContext";


export default function MasterPlan({ p }) {
  const { lang } = useAppContext();
  const [expanded, setExpanded] = useState(false);
  const [hovered, setHovered] = useState(false);

  const image = p.masterPlan || p.photos?.[1] || p.photos?.[0] || p.img;
  if (!image) return null;

  return (
    <>
      <section id="pd-masterplan" className="pd-section">
        <div className="fadeUp" style={{ marginBottom: "3rem" }}>
          <span className="pd-section-label">
            {lang === "en" ? "Site Layout" : "تصميم الموقع"}
          </span>
          <h2 className="pd-section-title">
            {lang === "en" ? "Master Plan" : "المخطط العام"}
          </h2>
          <div className="pd-section-bar" />
        </div>

        <div
          className="fadeUp d2"
          onClick={() => setExpanded(true)}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            position: "relative",
            borderRadius: 16,
            overflow: "hidden",
            cursor: "zoom-in",
            boxShadow: "0 24px 80px rgba(10,22,40,.14)",
            border: "1px solid rgba(201,168,76,.12)",
          }}
        >
          <img
            src={image}
            alt={lang === "en" ? "Master Plan" : "المخطط العام"}
            style={{ width: "100%", display: "block", maxHeight: 520, objectFit: "cover" }}
          />

          {/* Hover overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: hovered ? "rgba(10,22,40,.32)" : "rgba(10,22,40,0)",
              transition: "background .3s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "rgba(10,22,40,.78)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(201,168,76,.3)",
                borderRadius: 8,
                padding: ".65rem 1.25rem",
                display: "flex",
                alignItems: "center",
                gap: ".5rem",
                color: "var(--gold)",
                fontSize: ".75rem",
                fontFamily: "var(--sans)",
                letterSpacing: ".1em",
                textTransform: "uppercase",
                opacity: hovered ? 1 : 0,
                transition: "opacity .3s",
                pointerEvents: "none",
              }}
            >
              <ZoomIn size={15} />
              {lang === "en" ? "Click to Expand" : "انقر للتوسيع"}
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {expanded && (
        <div
          onClick={() => setExpanded(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.93)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            cursor: "zoom-out",
            animation: "fadeIn .2s ease",
          }}
        >
          <button
            onClick={() => setExpanded(false)}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              background: "rgba(255,255,255,.08)",
              border: "1px solid rgba(255,255,255,.15)",
              borderRadius: "50%",
              width: 42,
              height: 42,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              cursor: "pointer",
              transition: "background .2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,.15)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,.08)")}
          >
            <X size={18} />
          </button>
          <img
            src={image}
            alt={lang === "en" ? "Master Plan" : "المخطط العام"}
            style={{
              maxWidth: "95vw",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: 10,
              boxShadow: "0 32px 80px rgba(0,0,0,.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
